import axios from 'axios'

// django 的 csrf cookie 默认名称
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

import {Message} from 'element-ui'
//  REQUEST 请求异常拦截
axios.interceptors.request.use(config => {
    //==========  所有请求之前都要执行的操作  ==============
    return config;
}, err => {
    //==================  错误处理  ====================
    Message.error({message: '请求超时!'});
    return Promise.resolve(err);
})

//  RESPONSE 响应异常拦截
axios.interceptors.response.use(data => {
//==============  所有请求完成后都要执行的操作  ==================

    return data;
}, err => {
//==============  错误处理  ====================
    if (err && err.response) {
        switch (err.response.status) {
            case 400:
                err.message = `请求错误:${JSON.stringify(err.response.data)}`;
                break;
            case 401:
                err.message = '未授权，请重新登录(401)';
                break;
            case 403:
                err.message = '拒绝访问，您没有权限';
                break;
            case 404:
                err.message = '请求出错，地址不存在';
                break;
            case 408:
                err.message = '请求超时(408)';
                break;
            case 500:
                err.message = '服务器错误(500)';
                break;
            case 501:
                err.message = '服务未实现(501)';
                break;
            case 502:
                err.message = '网络错误(502)';
                break;
            case 503:
                err.message = '服务不可用(503)';
                break;
            case 504:
                err.message = '网络超时(504)';
                break;
            case 505:
                err.message = 'HTTP版本不受支持(505)';
                break;
            default:
                err.message = `连接出错(${err.response.status})!`;
        }
    } else {
        console.log(err)
        err.message = '连接服务器失败!'
    }
    Message.error(err.message)
    return Promise.reject(err);
})

export const postRequest = (url, data) => {
    return axios({
        method: 'post',
        url: url,
        data: data || {},
    });
}

export const getRequest = (url, params) => {
    const _params = params || {}
    return axios({
        method: 'get',
        url: url,
        params: _params
    });
}

export const putRequest = (url, data) => {
    return axios({
        method: 'put',
        url: url,
        data: data,
    });
}

//  PATCH 方法封装
export const patchRequest = (url, data) => {
    return axios({
        method: 'patch',
        url: url,
        data: data
    });
}

//  DELETE 方法封装
export const deleteRequest = (url) => {
    return axios({
        method: 'delete',
        url: url
    });
}

